import { ConfigurableProduct } from '@magentoTypes'

export const getRelatedSkus = (product: ConfigurableProduct) => {
  if (!product) return []

  const relatedProductsSkus =
    (product.related_products as ConfigurableProduct[])
      ?.flatMap((related) => related?.variants?.map((variant) => variant?.product?.sku) || [])
      .filter((sku): sku is string => !!sku) || []

  const productVariantsSkus =
    product.variants
      ?.map((variant) => variant?.product?.sku)
      .filter((sku): sku is string => !!sku) || []

  const uniqueSkus = new Set([...productVariantsSkus, ...relatedProductsSkus])

  return Array.from(uniqueSkus).sort()
}
